import React from 'react'
import {Button} from 'antd'
import {CalendarOutlined} from '@ant-design/icons'
import moment from 'moment'
import gql from 'graphql-tag'
import Query from 'shared/components/Query'
import Layout from 'components/PrivateRoutes/Layout'
import {Heading, Link} from 'components/shared'
import BookingsList from 'components/shared/BookingsList'
import BookingsMap from 'components/shared/BookingsMap'
import TodaysBookings from './TodaysBookings'
import PreviousBookings from './PreviousBookings'
import BookingOverviewReminders from 'components/shared/BookingOverviewReminders'

// Fetching today's bookings here instead of in its component because we need to
// know if there are pending key pickups today.
// A side effect of this is that today's bookings load and display before
// earlier bookings, but as today's booking are usually more relevant than
// earlier ones, this could actually be considered a performance improvement.
const TodaysBookingsQuery = gql`
  query TodaysBookingsQuery($after: DateTime, $before: DateTime, $sortDirection: SortDirection) {
    serviceProvider {
      id
      bookings(startsAfterDateTime: $after, startsBeforeDateTime: $before, sortByStartAt: $sortDirection) {
        ...BookingsList
        ...BookingsMap
      }
    }
  }
  ${BookingsList.fragments.bookingsList}
  ${BookingsMap.fragments.bookingsMap}
`

class Overview extends React.Component {
  state = {
    todaysBookingsMode: 'list',
  }

  toggleBookingsMode = () => {
    const {todaysBookingsMode} = this.state
    this.setState({
      todaysBookingsMode: todaysBookingsMode === 'list' ? 'map' : 'list'
    })
  }

  render() {
    const after = moment().startOf('day').format()
    const before = moment().endOf('day').format()

    const {todaysBookingsMode} = this.state
    return (
      <Query
        query={TodaysBookingsQuery}
        variables={{after, before, sortDirection: 'asc'}}
        inlineLoading
        inlineError
      >
        {({getData}) => {
          const bookings = getData('serviceProvider.bookings', {edges: []})

          return (
            <Layout {...this.props} title="Min oversikt">
              <div className="section">
                <BookingOverviewReminders bookings={bookings} />
                <Heading
                  title="Dagens bookinger"
                  actions={[
                    <Link
                      key="calendar"
                      to="/bookings/calendar"
                    >
                      <Button icon={<CalendarOutlined />} />
                    </Link>,
                    <Button key="mode" onClick={this.toggleBookingsMode}>
                      {todaysBookingsMode === 'list' ? 'Se i kart' : 'Se i liste'}
                    </Button>,
                  ]}
                />
                <TodaysBookings mode={todaysBookingsMode} bookings={bookings} />
              </div>

              <div className="section">
                <Heading title="Tidligere bookinger" />
                <PreviousBookings />
              </div>
            </Layout>
          )
        }}
      </Query>
    )
  }
}

export default Overview
